import { useMemo } from 'react';

import { createLocalizationProvider } from '@atlaskit/locale';

import type { WeekDay } from '../../types';

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default function useLocale({
	locale,
	weekStartDay,
}: {
	locale: string;
	weekStartDay: WeekDay;
}): {
	monthsLong: string[];
	daysShort: string[];
	daysLong: string[];
} {
	const l10n = useMemo(() => createLocalizationProvider(locale), [locale]);

	const monthsLong = useMemo(() => l10n.getMonthsLong(), [l10n]);
	const daysShort = useMemo(() => l10n.getDaysShort(weekStartDay), [l10n, weekStartDay]);
	const daysLong = useMemo(() => l10n.getDaysLong(weekStartDay), [l10n, weekStartDay]);

	return {
		monthsLong,
		daysShort,
		daysLong,
	};
}
